






















import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { Popover, Radio } from 'element-ui';
import { AcgnPop } from '@acgn/herm/src/ui';
import { namespace } from 'vuex-class';
const TaskGroupAction = namespace('desk/taskGroup').Action;
const TaskGroupGetter = namespace('desk/taskGroup').Getter;

@Component({
  components: {
    AcgnPop,
    [Radio.name]: Radio,
    [Popover.name]: Popover
  }
})
export default class AcgnDepot extends Vue {
  @Prop() public visible: any; // 是否显示弹框
  @Prop() public editItem: any; // 编辑信息
  @Prop() public refreshExamine: any; // 刷新环节
  @TaskGroupAction private setStoverDuestatus: any; // 逾期标识
  get show() {
    return this.visible;
  }
  set show(v) {
    this.$emit('update:visible', v);
  }

  private async submit() {
    const params = {
      link_id: this.editItem[3],
      over_submit_status: this.editItem[2],
      over_approve_status: this.editItem[1]
    };
    await this.setStoverDuestatus(params);
    this.refreshExamine();
    this.$message.success('修改成功');
    this.show = false;
  }
}
